(() => {
  const configElement = document.getElementById('GmlCountryLanguageConfig');
  const form = document.getElementById('GmlCountryLanguageForm');
  if (!configElement || !form || window.Shopify?.designMode) return;

  let config;
  try { config = JSON.parse(configElement.textContent); } catch { return; }
  const available = new Map((config.available || []).map(code => [String(code).toLowerCase(), code]));
  const countries = new Set((config.countries || []).map(code => String(code).toUpperCase()));
  const current = String(config.current || '').toLowerCase();
  const currentCountry = String(config.country || '').toUpperCase();
  if (!available.has(current) || !countries.has(currentCountry)) return;

  const preferenceKey = 'gml-language-choice-v1';
  const countryPreferenceKey = 'gml-country-choice-v1';
  const checkedKey = 'gml-country-language-checked-v2';
  const read = (storage, key) => {
    try { return window[storage].getItem(key); } catch { return null; }
  };
  const write = (storage, key, value) => {
    try {
      window[storage].setItem(key, value);
      return window[storage].getItem(key) === value;
    } catch { return false; }
  };
  const remember = language => {
    const code = String(language || '').toLowerCase();
    if (!available.has(code)) return;
    write('localStorage', preferenceKey, code);
    write('sessionStorage', preferenceKey, code);
  };
  const rememberCountry = country => {
    const code = String(country || '').toUpperCase();
    if (!countries.has(code)) return;
    write('localStorage', countryPreferenceKey, code);
    write('sessionStorage', countryPreferenceKey, code);
  };
  const preference = () => read('localStorage', preferenceKey) || read('sessionStorage', preferenceKey);
  const countryPreference = () => {
    const value = read('localStorage', countryPreferenceKey) || read('sessionStorage', countryPreferenceKey);
    return countries.has(value) ? value : null;
  };
  document.addEventListener('submit', event => {
    if (!(event.target instanceof HTMLFormElement) || event.target === form) return;
    const submitter = event.submitter;
    const languageInput = event.target.querySelector('[name="language_code"]');
    const countryInput = event.target.querySelector('[name="country_code"]');
    if (submitter?.name === 'language_code') remember(submitter.value);
    else if (languageInput?.matches('select,input:not([type="hidden"])')) remember(languageInput.value);
    if (submitter?.name === 'country_code') rememberCountry(submitter.value);
    else if (countryInput?.matches('select,input:not([type="hidden"])')) rememberCountry(countryInput.value);
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[hreflang],a[data-gml-language-choice]');
    if (link) remember(link.hreflang || link.dataset.gmlLanguageChoice);
  }, true);

  const pathLanguage = location.pathname.split('/')[1].toLowerCase();
  const params = new URLSearchParams(location.search);
  const regionalLanguage = /^[a-z]{2}-[a-z]{2,4}$/.test(pathLanguage) && available.has(pathLanguage.split('-')[0]);
  const localizedPath = available.has(pathLanguage) || regionalLanguage;
  const explicitLanguage = localizedPath || params.has('locale') || params.has('language') || params.has('language_code');
  const explicitCountry = params.has('country') || params.has('country_code') || params.has('currency');
  if (explicitLanguage || current !== 'en') remember(current);
  const languageLocked = explicitLanguage || current !== 'en' || Boolean(preference());
  const countryLocked = explicitCountry || Boolean(countryPreference());
  if ((languageLocked && countryLocked) || read('sessionStorage', checkedKey)) return;
  const routePath = localizedPath ? location.pathname.slice(pathLanguage.length + 1) || '/' : location.pathname;
  if (/^\/(?:account|admin|apps|cart|checkouts?|challenge|password)(?:[/.]|$)/i.test(routePath)) return;
  if (/^\/pages\/(?:contact|sell-your-watch)(?:[/.]|$)/i.test(routePath)) return;
  if (navigator.userActivation?.hasBeenActive || window.scrollX !== 0 || window.scrollY !== 0) return;
  if (document.activeElement?.matches('input,textarea,select,[contenteditable="true"]')) return;
  if (document.visibilityState !== 'visible') return;
  if (performance.getEntriesByType('navigation')[0]?.type === 'back_forward') return;
  if (!write('sessionStorage', checkedKey, '1')) return;

  let interacted = false;
  const controller = new AbortController();
  const stop = () => {
    interacted = true;
    controller.abort();
  };
  ['pointerdown', 'keydown', 'click', 'wheel', 'submit', 'input', 'change', 'focusin', 'touchstart'].forEach(type => document.addEventListener(type, stop, { capture: true, once: true, passive: true }));
  window.addEventListener('pagehide', stop, { once: true });
  window.addEventListener('popstate', stop, { once: true });

  const countryLanguages = [
    ['en', 'CA US'],
    ['es', 'AR BO CL CO CR CU DO EC ES GQ GT HN MX NI PA PE PR PY SV UY VE'],
    ['ar', 'AE BH DJ DZ EG EH IQ JO KM KW LB LY MA MR OM PS QA SA SD SO SY TN YE'],
    ['fr', 'FR MC'],
    ['it', 'IT SM VA'],
    ['zh-cn', 'CN']
  ];
  const languageFor = country => countryLanguages.find(([, codes]) => codes.split(' ').includes(country))?.[0] || 'en';
  const root = new URL(config.root || '/', location.origin);
  root.pathname = root.pathname.replace(/\/?$/, '/');
  const endpoint = new URL('browsing_context_suggestions.json', root);
  endpoint.searchParams.set('country[enabled]', 'true');
  endpoint.searchParams.set('language[enabled]', 'false');
  const timeout = window.setTimeout(() => controller.abort(), 1800);
  fetch(endpoint.href, { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' } })
    .then(response => response.ok ? response.json() : null)
    .then(data => {
      if (interacted || controller.signal.aborted || document.visibilityState !== 'visible') return;
      const detectedCountry = String(data?.detected_values?.country?.handle || '').toUpperCase();
      if (!/^[A-Z]{2}$/.test(detectedCountry)) return;
      const detectedLanguage = languageFor(detectedCountry);
      const country = !countryLocked && !countryPreference() && ['CA', 'US'].includes(detectedCountry) && countries.has(detectedCountry) ? detectedCountry : currentCountry;
      const language = !languageLocked && !preference() && available.has(detectedLanguage) ? detectedLanguage : current;
      if (language === current && country === currentCountry) return;
      const languageInput = form.querySelector('[name="language_code"]');
      const countryInput = form.querySelector('[name="country_code"]');
      const returnInput = form.querySelector('[name="return_to"]');
      if (!languageInput || !countryInput || !returnInput) return;
      languageInput.value = available.get(language);
      countryInput.value = country;
      returnInput.value = location.pathname + location.search + location.hash;
      HTMLFormElement.prototype.submit.call(form);
    })
    .catch(() => {})
    .finally(() => window.clearTimeout(timeout));
})();
